import { Box, Grid, Paper, Typography, List, ListItem, ListItemText, Button, IconButton, Divider, useMediaQuery, CircularProgress, Chip, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, } from '@mui/material';
import React, { useState, useEffect } from 'react';
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { alpha } from "@mui/material";
import { FormLabel } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useResponsiveStyles } from "../../Benchcandidates/responsiveStyles";
import Key from "../../../clientVariables.json";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import axios from "axios";


import { toast } from "react-toastify";
import { userSelector } from '../../user-redux/selector';
import { useSelector } from 'react-redux';
const CustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
    "& .MuiInputBase-input::placeholder": {
        color: alpha(theme.palette.text.primary, 0.5),
    },
    "& .MuiAutocomplete-inputRoot": {
        // height: '38px',
        padding: "1px",
    },
}));
const CustomTextField = styled(TextField)(({ theme }) => ({
    "& .MuiInputBase-input::placeholder": {
        color: alpha(theme.palette.text.primary, 0.5),
    },
    "& .MuiInputBase-root": {
        height: "40px",
    },
}));
const CustomDateTimePicker = styled(DateTimePicker)(({ theme }) => ({
    "& .MuiOutlinedInput-root .MuiInputBase-input::placeholder": {
        color: theme.palette.text.secondary,
    },
    "& .MuiOutlinedInput-root": {
        height: 40,
    },
}));

const Addjob = ({ createSuccessHandler, openJobsRefresh }) => {
    const {user} = useSelector(userSelector)

    const [show, setShow] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [jobs, setJobs] = useState([]); // Sample data for jobs
    const [editorFocused, setEditorFocused] = useState(false);
    const [jobTypeList, setJobTypeList] = useState([]);
    const [visaTypeList, setVisaTypeList] = useState([]);
    const [educationList, setEducationList] = useState([]);
    const [jobCategory, setJobcategory] = useState("")


    // Static company names list
    const [companyList, setCompanyList] = useState([
        { title: "Google" },
        { title: "Microsoft" },
        { title: "Apple" },
        { title: "Amazon" },
    ]);
    const [formData, setFormData] = useState({
        jobTitle: "",
        experience: "",
        qualification: {
            id: 5,
            title: "Bachelors Degree",
            isactive: 1,
            isdefault: 0,
            ordering: 5,
            serverid: 0,
        },
        jobType: [],
        visaTypeWorkPermit: [],
        workType: "onsite",
        state: "",
        city: "",
        zipcode: "",
        jobDescription: "",
        skills: [],
        newSkill: "",
        numberOfJobs: "",
        duration: "",
        keywords: [],
        newKeyword: "",
        salary: "",
        salaryType: "",
        screeners: "",
        no_of_jobs: "",
        videoUrl: "",
        duration: "",
        requiredTravel: "",
        startPublishing: null,
        termsAccepted: false,
    });
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [zipcodes, setZipcodes] = useState([]);
    const [skillLoading, setSkillsLoading] = useState(false);
    const styles = useResponsiveStyles();
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [currentUser, setCurrentUser] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [companynames, setCompanynames] = useState(null);
    const [open, setOpen] = useState(false); // For controlling the dialog
    const [newCompany, setNewCompany] = useState({
        companyName: "",
        email: "",
        phone: "",
        name: "",
        state: "",
        city: "",
        country: "",
    });
    const isDesktopLarge = useMediaQuery("(min-width: 1920px)");
    const isDesktopMedium = useMediaQuery(
        "(min-width: 1440px) and (max-width: 1919px)"
    );
    const isDesktopSmall = useMediaQuery(
        "(min-width: 1200px) and (max-width: 1439px)"
    );
    const isDesktopExtraSmall = useMediaQuery(
        "(min-width: 992px) and (max-width: 1199px)"
    );

 
    const handleShow = () => setShow(true);
    const handleCloseTerms = () => setShowTerms(false);
    const handleShowTerms = () => setShowTerms(true);

    const handleBlurChnage = (value) => {
        setEditorFocused(false);

        // handleChange("skills", []);
    };


    const handleChange = (field, value) => {
        if (field === "newSkill") {
            value = value?.trim();
        }

        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));

        // if (field === "jobDescription") {
        //     getAISkills(value);
        // }
    };

    const handleAddSkill = () => {
        const { newSkill, skills } = formData;
        if (newSkill.trim() !== "") {
            const updatedSkills = [...skills, newSkill.trim()];
            setFormData({
                ...formData,
                skills: updatedSkills,
                newSkill: "",
            });
            // validateForm(updatedSkills);
        }
    };

    const handleDeleteSkill = (skillToDelete) => {
        const updatedSkills = formData.skills.filter(
            (skill) => skill !== skillToDelete
        );
        setFormData({
            ...formData,
            skills: updatedSkills,
        });
        // validateForm(updatedSkills);


    };
    useEffect(() => {
        console.log("user :", user);
        getJobTypes();
        getVisaTypes();
        getEducationList();
        getStates();
        getCompanynames();
    }, []);
    const getEducationList = () => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_all_educations_list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                console.log("getEducationList", data.data);
                setEducationList(data.data);
            })
            .catch((error) => {
                console.error("Error fetching education types:", error);
            });
    };
    const getJobTypes = () => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_all_jobtypes`, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                console.log("getAllJobTypes", data.data);
                setJobTypeList(data.data);
            })
            .catch((error) => {
                console.error("Error fetching job types:", error);
            });
    };
    const getVisaTypes = () => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_all_visatypes`, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                console.log("get_all_visatypes", data.data);
                let filterdList = data.data.filter((each) => each.id !== 8);
                setVisaTypeList(data.data);
            })
            .catch((error) => {
                console.error("Error fetching job types:", error);
            });
    };

    const getCompanynames = () => {
        fetch(`${Key.domain_crm}/company/get_Companies_List`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                page: 0,
                limit: 20,
                searchBy: '',
                title: '',
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                console.log("get_all_visatypes", data);
                // let filterdList = data.data.filter((each) => each.id !== 8);
                 setCompanynames(data.data);
            })
            .catch((error) => {
                console.error("Error fetching company names:", error);
            });
    };
    const getStates = () => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_states_by_countryid`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                country_id: 233,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setStateList(data.data);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    };

    const getCities = (id) => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_cities_by_stateid`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                state_id: id,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setCityList(data.data);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    };

    const getZipCodes = (id) => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_zipcodes_By_cityId`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                city_id: id,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setZipcodes(data.data);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    };

    const getZipcodeCoordinates = (zipCode) => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_zipcode_coordinates`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                zipcode: zipCode,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                const cord = data.data && data.data.length > 0 ? data.data[0] : [];
                setZipcodes(cord);
            })
            .catch((error) => {
                console.error("Error fetching coordinates:", error);
            });
    };
    useEffect(() => {
        if (formData.state && formData.state !== "") {
            console.log("state id", formData.state);
            getCities(formData.state.id);
        }
    }, [formData.state]);

    useEffect(() => {
        if (formData.city && formData.city !== "") {
            console.log("state id", formData.city);
            getZipCodes(formData.city.id);
        }
    }, [formData.city]);

    useEffect(() => {
        if (formData.zipcode && formData.zipcode !== "") {
            getZipcodeCoordinates(formData.zipcode);
        }
    }, [formData.zipcode]);

    const topBarStyles = {
        padding: "4px",
        borderRadius: "4px",
        margin: "5px 5px 5px 5px",
        border: "none",
        alignItems: "center"
    };

    // Handle dialog open/close
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // Handle change to add new company
    const handlecompanyChange = (event, newValue) => {
        if (newValue?.title === "Add New Company") {
            handleOpen(); // Open the dialog when "Add New Company" is clicked
        } else {
            setFormData({ ...formData, company: newValue });
        }
    };

    // Handle input change for search
    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
    };

    // Prepend "Add New Company" to the options

    const getOptions = () => [
        { title: "Add New Company" }, // "Add New Company" option at the top
        ...(Array.isArray(companynames) ? companynames : []) // Spread companynames only if it's an array
    ];

    // Handle the new company form submission
    const handleeSubmit = () => {
        setCompanyList([...companyList, { title: newCompany.companyName }]);
        setFormData({ ...formData, company: { title: newCompany.companyName } });
        handleClose(); // Close the dialog after submission
    };

    // // Handle change in the form inputs
    // const handleNewCompanyChange = (e) => {
    //     const { name, value } = e.target;
    //     setNewCompany({ ...newCompany, [name]: value });
    // };
    const handleNewCompanyChange = (e) => {
        const { name, value } = e.target; // Get name and value from the input
        setNewCompany((prevState) => ({ ...prevState, [name]: value })); // Update the specific field
    };
    const validateForm = () => {
        const errors = {};
        if (!formData.jobTitle?.trim()) {
            errors.jobTitle = "Job Title is required";
        } else if (!formData.experience?.title?.trim()) {
            errors.experience = "Experience is required";
        } else if (!formData.qualification?.title?.trim()) {
            errors.qualification = "Qualification is required";
        } else if (!formData.jobType.length > 0) {
            errors.jobType = "job type is required";
        } else if (!formData.visaTypeWorkPermit.length > 0) {
            errors.visaTypeWorkPermit = "visa type is required";
        } else if (
            !formData.state?.name?.trim() &&
            formData.workType === "onsite"
        ) {
            errors.state = "State is required";
        } else if (
            !formData.city.cityName?.trim() &&
            formData.workType === "onsite"
        ) {
            errors.city = "City is required";
        } else if (
            !formData.jobDescription ||
            formData.jobDescription.trim() === "<p><br></p>"
        ) {
            errors.jobDescription = "Job Description is required";
        } else if (!formData.skills.length) {
            errors.skills = "Skills is required";
        } else if (formData.skills.length < 5) {
            errors.skills = "Minimum 5 skills are required";
        } else if (!formData.termsAccepted) {
            errors.termsAccepted = "You must accept the terms and conditions";
            toast.error("You must accept the terms and conditions", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        // if (!formData.zipcode.length > 0 && formData.workType === "onsite") {
        //   errors.zipcode = "Zipcode is required";
        // }

        return errors;
    };
    const createNotification = (contactname, jobid) => {
        axios
            .post(`${Key.domain}/Notifications/get_rec_followers`, {
                user_id: user.id,
            })
            .then((response) => {
                let followers = response.data.data;
                axios
                    .post(`${Key.domain}/Notifications/create_notification`, {
                        user_id: user.id,
                        notifiedto: followers,
                        notificationDescription: "" + contactname + " has posted a new job",
                        notificationSubject: "Your Recruiter posted a Job",
                        job_id: jobid,
                    })
                    .then((response) => { });
            });
    };
    useEffect(() => {
        console.log("errors", formErrors);
    }, [formErrors]);
    const handleSubmit = async (e) => {
        setLoadingSubmit(true);
        e.preventDefault();

        const errors = validateForm();
        setFormErrors(errors);

        if (Object.keys(errors).length === 0) {
            console.log("formData", formData);
            const selectedJobTypesID = formData.jobType
                .map((data) => data.id)
                .join(", ");
            const selectedVisaTypesID = formData.visaTypeWorkPermit
                .map((data) => data.id)
                .join(", ");
            const selectedJobTypesName = formData.jobType
                .map((data) => data.title)
                .join(", ");
            const selectedVisaTypesName = formData.visaTypeWorkPermit
                .map((data) => data.type_name)
                .join(", ");

            // let screenerId = screenersData.filter((data, index) => {
            //     return data.screener_name == formData.screeners;
            // });
            // console.log(screenerId);
            const payloadData = {
                user_id: user.id,
                employerName: user.full_name,
                username: user.username,
                session_token: user.session_token,
                ai_skills: formData?.skills.join(", "),
                company_id: user?.companyid,
                title: formData?.jobTitle,
                alias: formData?.jobTitle,
                jobtype: selectedJobTypesID,
                salaryrangetype: formData.salaryType.title,
                screener_id: formData.screeners?.id?.toString() || "",
                Description: formData.jobDescription,
                Qualifications: formData.qualification.title,
                preferredskillNames: formData?.skills.join(", "),
                country: formData.workType === "remote" ? "" : "233",
                state: formData.workType === "remote" ? "" : formData.state.id || "",
                city: formData.workType === "remote" ? "" : formData.city.id || "",
                contactname: user.full_name,
                contactphone: user.phone_number || "",
                contactemail: user.username,
                NoofJobs: formData.no_of_jobs,
                Duration: formData.duration,
                sendemaiil: "1",
                sendsms: "1",
                metadescription: "",
                metakeywords: formData.keywords.join(", "),
                workpermit: selectedVisaTypesID,
                requiredtravel: formData.requiredTravel.title,
                salaryrangefrom: formData.salary,
                video: formData.videoUrl,
                zipcode: formData.zipcode.zipcode,
                packageid: "1",
                shortRegion:
                    formData.workType === "remote"
                        ? ""
                        : formData.state.shortRegion || "",
                stateName:
                    formData.workType === "remote" ? "" : formData.state.name || "",
                experience: formData.experience.title,

                cityName:
                    formData.workType === "remote" ? "" : formData.city.cityName || "",
                companyName: user.company_name || "",
                workpermitName: selectedVisaTypesName || "",
                jobtypeName: selectedJobTypesName,
                salaryType: formData.salaryType.title,
                startpublishing: moment(formData.startPublishing).format(
                    "MMMM Do YYYY, h:mm:ss"
                ),
                stoppublishing: "0000-00-00 00-00-00",
                prefferdskillsName: formData?.skills || [],
                recruiter_view: 1,
                isRemote: formData.workType === "remote" ? 1 : false ? 2 : 0, //hybrid false
                map_enable: formData.workType === "remote" ? 0 : 1,
                address: "",
                latitude: "",
                longitude: "",
                posted_flag: 1,
                workmode: formData.workType === "remote" ? true : false,
                industry_type: jobCategory
            };

            console.log("paylod is :", payloadData);

            try {
                const response = await axios.post(
                    `${Key.domain}/Jobs/add_employer_job`,
                    payloadData
                );
                if (response.status === 200 && response.data.data.insertId) {
                    await addJobToSolr(response.data.data.insertId, payloadData);
                    createSuccessHandler(false);
                } else {
                    console.error("job Not posted");
                }
            } catch (error) {
                console.error("add_employer_job", error);
            }
        } else {
            const firstErrorField = Object.keys(errors)[0];
            document.getElementById(firstErrorField)?.focus();
        }
        setLoadingSubmit(false);
    };
    const addJobToSolr = async (jobId, data) => {
        try {
            const response = await axios.post(`${Key.domain}/solr/add_job_to_solr`, {
                session_token: data.session_token,
                contactemail: data.contactemail,
                city: formData.workType === "remote" ? "" : data.city,
                created: moment().format(),
                description: data.Description.replace(/['\\//]/g, ""),
                title: data.title,
                ai_skills: data.ai_skills,
                jobtype: data.jobtype,
                salaryrangefrom: data.salaryrangefrom,
                salaryrangetype: data.salaryrangetype,
                contactname: data.contactname,
                uid: data.user_id,
                companyid: data.company_id,
                requiredtravel: data.requiredtravel,
                id: jobId,
                contactphone: data.contactphone,
                state: formData.workType === "remote" ? "" : data.state,
                country: formData.workType === "remote" ? "" : data.country,
                workpermit: data.workpermit,
                shortRegion: formData.workType === "remote" ? "" : data.shortRegion,
                stateName: formData.workType === "remote" ? "" : data.stateName,
                cityName: formData.workType === "remote" ? "" : data.cityName,
                companyName: data.companyName,
                workpermitName: data.workpermitName,
                jobtypeName: data.jobtypeName,
                salaryType: data.salaryType,
                prefferdskillsName: data.prefferdskillsName,
                recruiter_view: data.recruiter_view,
                isRemote: data.isRemote,
                map_enable: data.map_enable,
                address: data.address,
                latitude: data.latitude,
                longitude: data.longitude,
                company_logo: "",
                qualifications: data.Qualifications,
                zipcode: data.zipcode,
                experience: data.experience,
                status: 1,
                posted_flag: 1,
                industry_type: data?.industry_type,
                workmode: formData.workType === "remote" ? true : false,
            });
            if (response.status === 200) {
                createNotification(data.contactname, jobId);
                const response = await axios.post(
                    `${Key.domain}/Jobs/send_mails_to_related_JS`,
                    {
                        jobid: jobId,
                        title: data.title,
                        location: `${data.cityName && data.shortRegion
                                ? `${data.cityName}, ${data.shortRegion}`
                                : "N/A"
                            }`,
                        company_name: user.company_name || "",
                    }
                );
                if (response.data.success === 1) {
                    let msg = "Job Posted Successfully!";
                    toast.success(msg, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    createSuccessHandler(false);
                    openJobsRefresh();
                } else {
                    toast.error("Something Went Wrong", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            } else {
                console.error("add_job_to_solr");
            }
        } catch (error) {
            console.error("add_job_to_solr", error);
        }
    };
    return (
        <Box >
            <Grid container spacing={1} >
                <Grid item xs={12}>
                    <Paper elevation={2} sx={topBarStyles} >
                        <Typography style={{ textAlign: "center", fontWeight: "600" }}>
                            #1195492

                            Cloud ETL Developer

                            7-10 Years

                            California City, California
                        </Typography>
                    </Paper>
                    <Paper
                        elevation={2}
                        sx={{
                            height: "calc(96vh - 1px)",
                            overflow: "auto",
                            backgroundColor: "#F8F8F8"
                        }}
                    >
                        <Grid container spacing={1}>
                            {/* Left side - Job list */}
                            <Grid item xs={3}>
                                <Box >
                                    <Paper elevation={1} sx={{ padding: 2 }}>
                                        <Typography variant="h6" gutterBottom>
                                            Job List
                                        </Typography>
                                        {jobs.length > 0 ? (
                                            <List>
                                                {jobs.map((job, index) => (
                                                    <ListItem key={index}>
                                                        <ListItemText
                                                            primary={job.title}
                                                            secondary={job.company}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        ) : (
                                            <Typography variant="body1" color="textSecondary">
                                                No jobs found
                                            </Typography>
                                        )}
                                    </Paper>
                                </Box>
                            </Grid>

                            {/* Right side - Form */}
                            <Grid item xs={9}>
                                <Box component="form" noValidate >
                                    <Paper elevation={1}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 3,
                                                bgcolor: "#fff",
                                                padding: "10px",
                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={handleSubmit}
                                                sx={{
                                                    width: 120,
                                                    height: 35,
                                                    bgcolor: "#406882",
                                                    p: 0,
                                                    textTransform: "capitalize",
                                                    "&:hover": { bgcolor: "#406882" },
                                                }}
                                            >
                                                {loadingSubmit ? (
                                                    <CircularProgress
                                                        style={{ borderRadius: "23px", color: "#ddd" }}
                                                        role="status"
                                                        size={20}
                                                        aria-hidden="true"
                                                    />
                                                ) : (
                                                    "Add Job"
                                                )}
                                            </Button>
                                            <IconButton>
                                                <CloseRounded />
                                            </IconButton>
                                        </Box>
                                        <Divider />
                                        <Grid container spacing={2} sx={{ p: 2 }}>
                                            <Grid item xs={4}>
                                                <FormControl variant="standard" fullWidth>
                                                    <FormLabel required>Company Name</FormLabel>
                                                    <CustomAutocomplete
                                                        disablePortal
                                                        fullWidth
                                                      
                                                        options={getOptions()}
                                                        
                                                        getOptionLabel={(option) => option.name}
                                                        value={formData.company}
                                                        onChange={handlecompanyChange}
                                                        inputValue={inputValue}
                                                        onInputChange={handleInputChange}
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder="Select or Add Company" />
                                                        )}
                                                        id="company-name"
                                                    />
                                                    {formErrors.company && (
                                                        <Typography color="error" variant="caption">
                                                            {formErrors.company}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            {/* Dialog for Adding New Company */}
                                            <Dialog open={open} onClose={handleClose}>
                                                <DialogTitle>Add New Company</DialogTitle>
                                                <Divider/>
                                                <DialogContent>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6}>
                                                            <FormControl variant="standard" fullWidth>
                                                                <FormLabel required>Company Name</FormLabel>
                                                                <CustomTextField
                                                                    placeholder="Company Name"
                                                                    name="companyName" // Ensure the 'name' attribute is provided
                                                                    value={newCompany.companyName || ""} // Ensure the value is bound to the state
                                                                    onChange={handleNewCompanyChange} // Calls the change handler
                                                                    id="companyName"
                                                                    autoComplete="off"
                                                                />
                                                            </FormControl>
                                                           
                                                        </Grid>
                                                        <Grid item xs={6}>

                                                            <FormControl variant="standard" fullWidth>
                                                                <FormLabel required>Email</FormLabel>
                                                                <CustomTextField
                                                                    placeholder="Email"
                                                                    name="companyEmail"
                                                                    value={newCompany.companyEmail|| ""}
                                                                    onChange={handleNewCompanyChange}
                                                                    // error={formErrors.jobTitle}
                                                                    // helperText={formErrors.jobTitle}
                                                                    id="companyemail"
                                                                    autoComplete="off"
                                                                />
                                                            </FormControl>
                                                           
                                                        </Grid>
                                                        <Grid item xs={6}>

                                                            <FormControl variant="standard" fullWidth>
                                                                <FormLabel required>Name</FormLabel>
                                                                <CustomTextField
                                                                    placeholder="Contact Name"
                                                                    name="companycontactname"
                                                                    value={newCompany.companycontactname || ""}
                                                                    onChange={handleNewCompanyChange}
                                                                    // error={formErrors.jobTitle}
                                                                    // helperText={formErrors.jobTitle}
                                                                    id="contactname"
                                                                    autoComplete="off"
                                                                />
                                                            </FormControl>
                                                            
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <FormControl variant="standard" fullWidth>
                                                                <FormLabel required>Phone</FormLabel>
                                                                <CustomTextField
                                                                    placeholder="Contact Phone"
                                                                    value={newCompany.phone}
                                                                    onChange={handleNewCompanyChange}
                                                                    // error={formErrors.jobTitle}
                                                                    // helperText={formErrors.jobTitle}
                                                                    id="contactphone"
                                                                    autoComplete="off"
                                                                />
                                                            </FormControl>
                                                         
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <FormControl variant="standard" fullWidth>
                                                                <FormLabel required>State</FormLabel>
                                                                <CustomTextField
                                                                    placeholder="State"
                                                                    value={newCompany.state}
                                                                    onChange={handleNewCompanyChange}
                                                                    // error={formErrors.jobTitle}
                                                                    // helperText={formErrors.jobTitle}
                                                                    id="companystate"
                                                                    autoComplete="off"
                                                                />
                                                            </FormControl>
                                                           
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <FormControl variant="standard" fullWidth>
                                                                <FormLabel required>City</FormLabel>
                                                                <CustomTextField
                                                                    placeholder="City"
                                                                    value={newCompany.city}
                                                                    onChange={handleNewCompanyChange}
                                                                    // error={formErrors.jobTitle}
                                                                    // helperText={formErrors.jobTitle}
                                                                    id="companycity"
                                                                    autoComplete="off"
                                                                />
                                                            </FormControl>
                                                           
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <FormControl variant="standard" fullWidth>
                                                                <FormLabel required>Website</FormLabel>
                                                                <CustomTextField
                                                                    placeholder="Website"
                                                                    value={newCompany.website}
                                                                    onChange={handleNewCompanyChange}
                                                                    // error={formErrors.jobTitle}
                                                                    // helperText={formErrors.jobTitle}
                                                                    id="companywebsite"
                                                                    autoComplete="off"
                                                                />
                                                            </FormControl>
                                                            
                                                        </Grid>
                                                    </Grid>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleClose} variant="outlined" >Cancel</Button>
                                                    <Button onClick={handleeSubmit} variant="contained" color="primary">
                                                        Add Company
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                            <Grid item xs={4}>
                                                <FormControl variant="standard" fullWidth>
                                                    <FormLabel required>Job Title</FormLabel>
                                                    <CustomTextField
                                                        placeholder="Job Title"
                                                      value={formData.jobTitle}
                                                        onChange={(e) => handleChange("jobTitle", e.target.value)}
                                                   error={formErrors.jobTitle}
                                                     helperText={formErrors.jobTitle}
                                                        id="jobTitle"
                                                        autoComplete="off"
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <FormControl variant="standard" fullWidth>
                                                    <FormLabel required>Experience</FormLabel>
                                                    <CustomAutocomplete
                                                        disablePortal
                                                        fullWidth
                                                        options={experienceListData}
                                                        getOptionLabel={(option) => option.title}
                                                        value={formData.experience !== "" ? formData.experience : null}
                                                        onChange={(event, newValue) =>
                                                            handleChange("experience", newValue)
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder="Experience" />
                                                        )}
                                                        error={formErrors.experience}
                                                        helperText={formErrors.experience}
                                                        id="experience"
                                                    />
                                                    {formErrors.experience && (
                                                        <Typography color="error" variant="caption">
                                                            {formErrors.experience}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <FormControl variant="standard" fullWidth>
                                                    <FormLabel required>Qualification</FormLabel>
                                                    <CustomAutocomplete
                                                        disablePortal
                                                        fullWidth
                                                        options={educationList}
                                                        getOptionLabel={(option) => option.title}
                                                        value={
                                                            formData.qualification !== "" ? formData.qualification : null
                                                        }
                                                        onChange={(event, newValue) =>
                                                            handleChange("qualification", newValue)
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder="Qualification" />
                                                        )}
                                                        error={formErrors.qualification ? true : false}
                                                        helperText={formErrors.qualification}
                                                        id="qualification"
                                                    />
                                                    {formErrors.qualification && (
                                                        <Typography color="error" variant="caption">
                                                            {formErrors.qualification}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <FormControl variant="standard" fullWidth>
                                                    <FormLabel required>Job Type</FormLabel>
                                                    <CustomAutocomplete
                                                        multiple
                                                        fullWidth
                                                        limitTags={1}
                                                        size="small"
                                                        options={jobTypeList}
                                                        getOptionLabel={(option) => option.title}
                                                        value={formData.jobType !== "" ? formData.jobType : null}

                                                        onChange={(event, newValue) =>
                                                            handleChange("jobType", newValue)
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=""
                                                                placeholder="Job Type"
                                                            // {...params.TextFieldProps}
                                                            // sx={{ padding: "2px" }}
                                                            />
                                                        )}
                                                        error={formErrors.jobType}
                                                        helperText={formErrors.jobType}
                                                        id="jobType"
                                                    />
                                                    {formErrors.jobType && (
                                                        <Typography color="error" variant="caption">
                                                            {formErrors.jobType}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <FormControl variant="standard" fullWidth>
                                                    <FormLabel required>VisaType /Work Permit</FormLabel>
                                                    <CustomAutocomplete
                                                        multiple
                                                        fullWidth
                                                        limitTags={1}
                                                        size="small"
                                                        options={visaTypeList}
                                                        getOptionLabel={(option) => option.type_code}
                                                        value={
                                                            formData.visaTypeWorkPermit !== ""
                                                                ? formData.visaTypeWorkPermit
                                                                : null
                                                        }
                                                        // defaultValue={[
                                                        //   top100Films[13],
                                                        //   top100Films[12],
                                                        //   top100Films[11],
                                                        // ]}
                                                        // renderOption={(props, option, { selected }) => (
                                                        //   <li {...props}>
                                                        //     <Checkbox
                                                        //       icon={icon}
                                                        //       checkedIcon={checkedIcon}
                                                        //       style={{ marginRight: 8 }}
                                                        //       checked={selected}
                                                        //     />
                                                        //     {option.type_code}
                                                        //   </li>
                                                        // )}
                                                        onChange={(event, newValue) =>
                                                            handleChange("visaTypeWorkPermit", newValue)
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=""
                                                                placeholder="Visa Type"
                                                                {...params.TextFieldProps}
                                                                sx={{ padding: "2px" }}
                                                            />
                                                        )}
                                                        error={formErrors.visaTypeWorkPermit}
                                                        helperText={formErrors.visaTypeWorkPermit}
                                                        id="visaTypeWorkPermit"
                                                    />
                                                    {formErrors.visaTypeWorkPermit && (
                                                        <Typography color="error" variant="caption">
                                                            {formErrors.visaTypeWorkPermit}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl>
                                                    <FormLabel id="demo-row-radio-buttons-group-label">
                                                        Work Type
                                                    </FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group"
                                                        value={formData.workType}
                                                        onChange={(event) =>
                                                            handleChange("workType", event.target.value)
                                                        }
                                                    >
                                                        <FormControlLabel
                                                            value="remote"
                                                            control={<Radio />}
                                                            label="Remote"
                                                        />
                                                        <FormControlLabel
                                                            value="onsite"
                                                            control={<Radio />}
                                                            label="Onsite"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                            {formData && formData.workType === "onsite" && (
                                                <>
                                                    <Grid item xs={4}>
                                                        <FormControl variant="standard" fullWidth>
                                                            <FormLabel required>State</FormLabel>
                                                            <CustomAutocomplete
                                                                disablePortal
                                                                fullWidth
                                                                options={stateList}
                                                                getOptionLabel={(option) => option.name}
                                                                value={formData.state !== "" ? formData.state : null}
                                                                onChange={(event, newValue) =>
                                                                    handleChange("state", newValue)
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField {...params} placeholder="State" />
                                                                )}
                                                                error={formErrors.state}
                                                                helperText={formErrors.state}
                                                                id="state"
                                                                disabled={formData && formData.workType === "remote"}
                                                            />
                                                            {formErrors.state && (
                                                                <Typography color="error" variant="caption">
                                                                    {formErrors.state}
                                                                </Typography>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <FormControl variant="standard" fullWidth>
                                                            <FormLabel required>City</FormLabel>
                                                            <CustomAutocomplete
                                                                disablePortal
                                                                fullWidth
                                                                options={cityList}
                                                                getOptionLabel={(option) => option.cityName}
                                                                value={formData.city !== "" ? formData.city : null}
                                                                onChange={(event, newValue) =>
                                                                    handleChange("city", newValue)
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField {...params} placeholder="City" />
                                                                )}
                                                                error={formErrors.city}
                                                                helperText={formErrors.city}
                                                                id="city"
                                                                disabled={formData && formData.workType === "remote"}
                                                            />
                                                            {formErrors.city && (
                                                                <Typography color="error" variant="caption">
                                                                    {formErrors.city}
                                                                </Typography>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <FormControl variant="standard" fullWidth>
                                                            <FormLabel>Zipcode</FormLabel>
                                                            <CustomAutocomplete
                                                                disablePortal
                                                                fullWidth
                                                                options={zipcodes}
                                                                getOptionLabel={(option) => option.zipcode}
                                                                value={formData.zipcode !== "" ? formData.zipcode : null}
                                                                onChange={(event, newValue) =>
                                                                    handleChange("zipcode", newValue)
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Zipcode"
                                                                    //   inputProps={{
                                                                    //     type: "text",
                                                                    //     pattern: "\\d*",
                                                                    //     maxLength: 6,
                                                                    //   }}
                                                                    />
                                                                )}
                                                                error={formErrors.zipcode}
                                                                helperText={formErrors.zipcode}
                                                                id="zipcode"
                                                                disabled={formData && formData.workType === "remote"}
                                                            />
                                                            {formErrors.zipcode && (
                                                                <Typography color="error" variant="caption">
                                                                    {formErrors.zipcode}
                                                                </Typography>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid item xs={8}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12}>
                                                        <FormControl variant="standard" fullWidth>
                                                            <FormLabel required>
                                                                Job Description&nbsp;
                                                                <Typography
                                                                    component="span"
                                                                    onClick={handleShow}
                                                                    style={{
                                                                        color: "#406882",
                                                                        fontSize: "12px",
                                                                        fontWeight: 500,
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                        // '&:hover': {
                                                                        //     textDecoration: 'underline',
                                                                        // }
                                                                    }}
                                                                >
                                                                    Review list of Job Postings not permitted on Jobsnprofiles
                                                                </Typography>
                                                            </FormLabel>
                                                        </FormControl>
                                                        <div>
                                                            {formErrors.jobDescription && (
                                                                <span style={{ color: "red" }}>
                                                                    {formErrors.jobDescription}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div style={{ height: "350px", width: "100%" }}>
                                                            <ReactQuill
                                                                value={
                                                                    formData.jobDescription !== ""
                                                                        ? formData.jobDescription
                                                                        : null
                                                                }
                                                                onChange={(value) => handleChange("jobDescription", value)}
                                                                // onFocus={() => setEditorFocused(true)}
                                                                onBlur={(value) => handleBlurChnage(value)}
                                                                modules={{
                                                                    toolbar: [
                                                                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                                                        ["bold", "italic", "underline", "strike", "blockquote"],
                                                                        [{ color: [] }, { background: [] }],
                                                                        [{ align: [] }],
                                                                        [{ list: "ordered" }, { list: "bullet" }],
                                                                        ["code-block"],
                                                                        ["link", "image", "video"],
                                                                        ["clean"],
                                                                    ],
                                                                }}
                                                                placeholder="Enter your message..."
                                                                style={{ height: "320px" }}
                                                                id="jobDescription"
                                                            />
                                                        </div>
                                                        {/* <div>
                  {formErrors.jobDescription && (
                    <span style={{ color: "red" }}>
                      {formErrors.jobDescription}
                    </span>
                  )}
                </div> */}
                                                        {/* </FormControl> */}
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12}>
                                                        <FormControl variant="standard" fullWidth>
                                                            <FormLabel required>Skills</FormLabel>
                                                            <CustomTextField
                                                                placeholder="Type a skill and press Enter"
                                                                value={formData.newSkill}
                                                                onChange={(e) => handleChange("newSkill", e.target.value)}
                                                                // onChange={handleInputChange("newSkill")}
                                                                onKeyPress={(e) => {
                                                                    if (e.key === "Enter") {
                                                                        e.preventDefault();
                                                                        handleAddSkill();
                                                                    }
                                                                }}
                                                                error={formErrors.skills}
                                                                helperText={formErrors.skills}
                                                                id="skills"
                                                            />
                                                        </FormControl>
                                                        {skillLoading ? (
                                                            <Box
                                                                sx={{ display: "flex", mt: 2, justifyContent: "center" }}
                                                            >
                                                                <CircularProgress />
                                                            </Box>
                                                        ) : (
                                                            <div style={{ marginTop: "6px" }}>
                                                                {Array.isArray(formData.skills) &&
                                                                    formData.skills.length > 0 &&
                                                                    formData.skills.map((skill, index) => (
                                                                        <Chip
                                                                            key={skill}
                                                                            label={skill}
                                                                            onDelete={() => handleDeleteSkill(skill)}
                                                                            sx={{ marginRight: "8px", marginBottom: "8px" }}
                                                                        />
                                                                    ))}
                                                            </div>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sx={{
                                                    mt: isDesktopLarge
                                                        ? 5
                                                        : isDesktopMedium
                                                            ? 6
                                                            : isDesktopSmall
                                                                ? 10
                                                                : isDesktopExtraSmall
                                                                    ? 12
                                                                    : 12,
                                                }}
                                            >
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12}>
                                                        <Typography paragraph sx={{ m: 0 }}>
                                                            Add More Details (optional)
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={4}>
                                                                <FormControl variant="standard" fullWidth>
                                                                    <FormLabel>No Of Jobs</FormLabel>
                                                                    <CustomTextField
                                                                        placeholder="No Of Jobs"
                                                                        value={formData.no_of_jobs}
                                                                        onChange={(e) =>
                                                                            handleChange("no_of_jobs", e.target.value)
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <FormControl variant="standard" fullWidth>
                                                                    <FormLabel>Duration</FormLabel>
                                                                    <CustomTextField
                                                                        placeholder="Duration"
                                                                        value={formData.duration}
                                                                        onChange={(e) =>
                                                                            handleChange("duration", e.target.value)
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <FormControl variant="standard" fullWidth>
                                                                    <FormLabel>Required Travel</FormLabel>
                                                                    <CustomAutocomplete
                                                                        disablePortal
                                                                        fullWidth
                                                                        options={travelTypeListData}
                                                                        getOptionLabel={(option) => option.title}
                                                                        value={
                                                                            formData.requiredTravel !== ""
                                                                                ? formData.requiredTravel
                                                                                : null
                                                                        }
                                                                        onChange={(event, newValue) =>
                                                                            handleChange("requiredTravel", newValue)
                                                                        }
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                placeholder="Required Travel"
                                                                            />
                                                                        )}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <FormControl variant="standard" fullWidth>
                                                                    <FormLabel>Salary Type</FormLabel>
                                                                    <CustomAutocomplete
                                                                        disablePortal
                                                                        fullWidth
                                                                        options={salaryTypeListData}
                                                                        getOptionLabel={(option) => option.title}
                                                                        value={
                                                                            formData.salaryType !== ""
                                                                                ? formData.salaryType
                                                                                : null
                                                                        }
                                                                        onChange={(event, newValue) =>
                                                                            handleChange("salaryType", newValue)
                                                                        }
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} placeholder="Salary Type" />
                                                                        )}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <FormControl variant="standard" fullWidth>
                                                                    <FormLabel>Salary</FormLabel>
                                                                    <CustomTextField
                                                                        placeholder="Salary"
                                                                        value={formData.salary}
                                                                        onChange={(e) => handleChange("salary", e.target.value)}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                <Grid item xs={4}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        sx={{
                                                                            "& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root":
                                                                            {
                                                                                height: "40px",
                                                                            },
                                                                        }}
                                                                    >
                                                                        <FormLabel> Start Publishing</FormLabel>
                                                                        <CustomDateTimePicker
                                                                            fullWidth
                                                                            inputVariant="outlined"
                                                                            value={formData.startPublishing || null}
                                                                            onChange={(value) =>
                                                                                handleChange("startPublishing", value)
                                                                            }
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params.inputProps}
                                                                                    placeholder="MMMM Do YYYY, h:mm:ss"
                                                                                    sx={{ height: "40px !important" }}
                                                                                />
                                                                            )}
                                                                            minDate={moment()}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            </LocalizationProvider>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={formData.termsAccepted}
                                                                    onChange={(e) =>
                                                                        handleChange("termsAccepted", e.target.checked)
                                                                    }
                                                                    color="primary"
                                                                />
                                                            }
                                                            onClick={handleShowTerms}
                                                            label="I accept the terms and conditions"
                                                            sx={{
                                                                "&:hover": {
                                                                    color: "#406882",
                                                                    textDecoration: "underline",
                                                                },
                                                            }}
                                                        />
                                                        {formErrors.termsAccepted && (
                                                            <Typography color="error" variant="caption">
                                                                {formErrors.termsAccepted}
                                                            </Typography>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12}></Grid>
                                                    <Grid item xs={12}></Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Addjob;

const experienceListData = [
    { key: 0, value: 0, title: "0-3 Years" },
    { key: 1, value: 1, title: "4-6 Years" },
    { key: 2, value: 2, title: "7-10 Years" },
    { key: 3, value: 3, title: "above 10 Years" },
];

const travelTypeListData = [
    { key: 0, value: 0, title: "Not Required" },
    { key: 1, value: 1, title: "25%" },
    { key: 2, value: 2, title: "50%" },
    { key: 3, value: 3, title: "75%" },
    { key: 4, value: 4, title: "100%" },
];

const salaryTypeListData = [
    {
        id: 1,
        title: "Per Year",
        status: 1,
        isdefault: 0,
        ordering: 5,
        serverid: 0,
    },
    {
        id: 6,
        title: "Per Hour",
        status: 1,
        isdefault: 1,
        ordering: 1,
        serverid: null,
    },
];
